import { Input, Button } from 'ant-design-vue'

export default {
  name: 'air-verification-code',
  props: {
    /**
     * 验证码校验方法 PromiseFunction(value) resolve: 发送成功, reject(err): 发送失败(失败原因)
     */
    sendCode: {
      type: Function,
      required: true
    },
    /**
     * 验证码字符长度
     */
    maxLength: {
      type: Number,
      default: 4
    },
    /**
     * 间隔时间
     */
    timeout: {
      type: Number,
      default: 60
    },
    /**
     * 按钮默认文字
     */
    actionText: {
      type: String,
      default: '点击发送验证码'
    },
    /**
     * 错误是否自己处理
     */
    handlerErrorBySelf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cd: 0,
      loading: false
    }
  },
  render (h) {
    const { $attrs, $props, $scopedSlots, $listeners, cd, loading } = this
    const props = {
      attrs: {
        ...$attrs
      },
      class: {
        'air-verification-code': true
      },
      props: $props,
      on: $listeners,
      scopedSlots: $scopedSlots
    }
    const actionProps = {
      props: {
        type: 'primary',
        size: $attrs.size || 'default',
        disabled: !!cd,
        loading
      },
      slot: 'addonAfter',
      on: {
        click: this.onSend
      }
    }

    return (
      <Input {...props}>
        <Button {...actionProps}>
          { cd ? `${cd}S后可再次发送` : $props.actionText }
        </Button>
      </Input>
    )
  },
  methods: {
    onChange () {
      const { value } = this

      /**
       * 输入回调
       *
       * @event change
       * @param { String } value - 验证码
       */
      this.$emit('change', value)
    },
    onSend () {
      const { sendCode, timeout, handlerErrorBySelf } = this

      if (typeof sendCode === 'function') {
        const prom = sendCode()

        if (prom instanceof Promise) {
          this.loading = true

          prom.then(() => {
            this.loading = false
            this.cd = timeout
            const timer = setInterval(() => {
              this.cd -= 1

              if (this.cd === 0) {
                clearInterval(timer)
              }
            }, 1000)
          }).catch(err => {
            this.loading = false
            this.cd = 0

            if (!handlerErrorBySelf) {
              this.$message.error(err.message)
            }
          })
        } else {
          throw new Error('sendCode must be a function return Promise')
        }
      } else {
        throw new Error('sendCode must required')
      }
    }
  }
}
